/*global jQuery, dis */

/* DIS/PLAY Script
 Author's name: Anders Gissel
 Modified by:
 Client name: Hørsholm municipality
 Date of creation: Dec. 16th, 2015
 */


(function ($, dis) {
	"use strict";


	/**
	 * This module can set up a parallax-effect on background images by offsetting their Y-position. That's about it.
	 *
	 * @param objectConfiguration - The configuration for the object
	 * @param {jQuery|HTMLElement|string|*} objectConfiguration.container - The DOM-container for this instantiation
	 * @constructor
	 * @extends dis.BaseModule
	 */
	dis.ui.ParallaxImage = function (objectConfiguration) {

		// Fire the basemodule-initiator on this module.
		dis.BaseModule.call(this);

		var defaults = {
				startPosition: 80,
				stopPosition: 20
			},
			configuration = $.extend(defaults, objectConfiguration),
			dom = {},
			positionDelta = configuration.stopPosition - configuration.startPosition,
			objectOffset = 0,
			objectHeight = 0,
			scrollPositionWhenObjectEntersScreen = 0,
			scrollPositionWhenObjectLeavesScreen = 0,
			scrollPositionDelta,

			selfScope = this;



		function setParallaxPosition() {

			if (selfScope.currentScreenMode >= selfScope.screenSizes.tablet) {

				var curScrollPosition = selfScope.globalDOM.window.scrollTop(),
					positionPercentage,
					backgroundYPosition;

				if (curScrollPosition >= scrollPositionWhenObjectEntersScreen && curScrollPosition <= scrollPositionWhenObjectLeavesScreen) {
					positionPercentage = (curScrollPosition - scrollPositionWhenObjectEntersScreen) / scrollPositionDelta;
					backgroundYPosition = positionPercentage * positionDelta;

					dom.container.css("background-position-y", (backgroundYPosition + configuration.startPosition) + "%");
				}

			}


		}



		function reInit() {

			objectOffset = dom.container.offset().top;
			objectHeight = dom.container.outerHeight();

			scrollPositionWhenObjectEntersScreen = objectOffset - selfScope.currentWindowHeight;
			scrollPositionWhenObjectLeavesScreen = objectOffset + objectHeight;
			scrollPositionDelta = scrollPositionWhenObjectLeavesScreen - scrollPositionWhenObjectEntersScreen;

			if (selfScope.currentScreenMode >= selfScope.screenSizes.tablet) {
				setParallaxPosition();
			} else {
				dom.container.css("background-position-y", "");
			}
		}



		/**
		 * Initialization function, which is run when the module is "booting".
		 */
		function init() {

			dom.container = $(configuration.container);

			if (dom.container.length) {

				window.setTimeout(function () {
					selfScope.onWindowResize(reInit);
					selfScope.globalDOM.window.scroll(setParallaxPosition);

					reInit();
				}, 100);

			}

		}

		// Once everything is ready, run the init-function to get the ball rolling. The "onReady()" function lives
		// in dis.base.js.
		selfScope.onReady(init);

	};

	dis.ui.ParallaxImage.prototype = new dis.BaseModule();
	dis.ui.ParallaxImage.constructor = dis.ui.ParallaxImage;

}(jQuery, dis));